/*
		util.js,
			A few miscellaneous helpers.
 */

/*#include <base.js>
#include <class.js>
#include <browser.js>
#include <dom.js>
#include <event.js>*/

var Browser = require('./browser.js');
var DOM = require('./dom.js');
var Event = require('./event.js');
var Class = require('./class.js');

var Util = module.exports = {
	getWindowSize: function() {
		var w, h;

		if(Browser.isIE) {
			w = document.documentElement.clientWidth;		// standards mode IE 6
			h = document.documentElement.clientHeight;
			if(h == 0)
				h = document.body.clientHeight;		// old IE
		}
		else {
			w = window.innerWidth;
			h = window.innerHeight;
		}

		return {'w': w, 'h': h};
	},

	fixdrag: function(img) {
		if(Browser.isIE) {
			img.ondragstart = function(evt) {
				evt = evt || event;
				evt.returnValue = false;
				return false;
			}
		}
	},

	unfixdrag: function(img) {
		if(Browser.isIE) {
			img.ondragstart = null;		/* so stupid IE can GC this DOM node */
		}
	},

	now: function() {
		var n = new Date();
		return n.getTime();
	},

	ScreenSizer: Class(null, {
		__init__: function(control) {
			this.control = control;
			this.check();
			Event.observe(window, 'resize', this, this.check);
		},

		check: function() {
			var size = Util.getWindowSize();
			if(this.control._w != size.w || this.control._h != size.h)
				DOM.place(this.control, undefined, undefined, size.w, size.h);
		}
	})
}

